/* ============
 * VuetifyGoogleAutocomplete
 * ============
 *
 * https://github.com/MadimetjaShika/vuetify-google-autocomplete
 */
import Vue from 'vue';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyAkYUvbjQR-XjNP3uAr4t9Gduh-81wIMA8', // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
});
